export default () => {
  const watermark = $('.watermark');
  if (watermark.length) {
    const offset = 350;
    const fromTop = $('.hero').offset().top + $('.hero').height() + offset
    watermark.css({'top': fromTop + 'px'})
  }
}



// WEBPACK FOOTER //
// ./wp/wp-content/themes/ukrainian-museum-theme/src/scripts/modules/watermark.js